import { alpha, styled } from '@ltvco/refresh-lib/theme';
import { Link as RouterLink } from 'react-router-dom';

export const McpImage = styled('img')({ display: 'block', flexShrink: 0 });

export const PlainButton = styled('button')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: 0,
  border: 0,
  background: 'none',
  font: 'inherit',
  color: theme.palette.text.primary,
  cursor: 'pointer',
}));

/** Pill-shaped primary call to action that navigates like a real link. */
export const PromoCtaLink = styled(RouterLink, {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  alignSelf: 'flex-start',
  flexShrink: 0,
  height: compact ? 38 : 46,
  padding: theme.spacing(0, compact ? 2.5 : 3.25),
  borderRadius: '100px',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  fontSize: compact ? 14 : 15,
  fontWeight: 700,
  textDecoration: 'none',
  boxShadow: `0 4px 14px 0 ${alpha(theme.palette.primary.main, 0.3)}`,
  '&:hover': { backgroundColor: theme.palette.primary.dark },
}));
